export default __webpack_public_path__ + "static/media/en_flag.cb222569.svg";